import { Link as RouterLink } from "react-router-dom";
import { Link, Stack, Typography } from "@mui/material";

import { useAvaCaseIQContext } from "./AvaCaseIQProvider";
import { useAvaDialogContext } from "./AvaDialogContextProvider";

export const AvaCreateTicketHeader = ({ bigWidth }: { bigWidth: boolean }) => {
  const { setIsCaseIQOpen } = useAvaCaseIQContext();
  const { handleCloseAvaDialog } = useAvaDialogContext();

  return (
    <Stack
      sx={{ width: bigWidth ? 980 : "100%" }}
      alignItems={bigWidth ? "center" : "flex-start"}
      pb={bigWidth ? 3 : 2}
      data-cy="ava-create-ticket-header"
    >
      <Typography variant={bigWidth ? "h1" : "subtitle1"} fontWeight={500}>
        How can we help you today?
      </Typography>

      <Typography variant={bigWidth ? "body1" : "caption"} color="text.secondary">
        Alternatively, receive an instant response via{" "}
        <Link
          onClick={() => {
            setIsCaseIQOpen(false);
          }}
          color="primary"
          sx={{ cursor: "pointer", textDecoration: "none" }}
        >
          chat
        </Link>{" "}
        or our{" "}
        <Link
          color="primary"
          sx={{ cursor: "pointer", textDecoration: "none" }}
          onClick={() => {
            handleCloseAvaDialog();
          }}
          component={RouterLink}
          to="./professional-services"
        >
          professional services
        </Link>
        .
      </Typography>
    </Stack>
  );
};
